import type { ComponentType, ReactNode } from 'react';
import type { LucideProps } from 'lucide-react';
import { cn } from '../lib/cn.js';

export interface EmptyStateProps {
  icon?: ComponentType<LucideProps>;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center px-6 py-12 gap-3',
        className,
      )}
    >
      {Icon && (
        <span className="inline-flex size-14 items-center justify-center rounded-full bg-bg-surface-2 border border-border-subtle text-text-secondary">
          <Icon className="size-6" aria-hidden />
        </span>
      )}
      <h3 className="text-xl font-semibold text-text-primary">{title}</h3>
      {description && <p className="max-w-md text-base text-text-secondary">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
